import { useCart } from "../../hooks/use-cart";

interface CartBadgeProps {}

const CartBadge: React.FC<CartBadgeProps> = () => {
  const { numItemsInCart } = useCart();
  return (
    <span className="translate-middle badge rounded-pill">
      {numItemsInCart}
      <span className="visually-hidden">items in cart</span>
    </span>
  );
};

export default CartBadge;
